package com.iregained.site.components.sections.product.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateX
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val FeatureListItemStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.color(palette.custom.darkText).transition(
                Transition.of("transform", 0.2.s, TransitionTimingFunction.EaseOut), Transition.of("color", 0.2.s)
            )
    }
    hover {
        Modifier.translateX(6.px) // Slide right to signify interaction
            .color(palette.brand.primary) // Highlight brand teal
    }
}